var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgZoomIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 11.984v-1.597h-2.517V8h-1.651v2.387H7.5v1.597h2.832V14.5h1.651v-2.516H14.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.158 17.839a7.293 7.293 0 0 0 4.128-1.267L18.832 20 20 18.871l-3.482-3.366a6.765 6.765 0 0 0 1.797-4.586C18.315 7.098 15.11 4 11.157 4 7.206 4 4 7.098 4 10.92c0 3.82 3.205 6.919 7.158 6.919Zm0-1.597c3.04 0 5.505-2.383 5.505-5.323 0-2.939-2.465-5.322-5.505-5.322-3.041 0-5.506 2.383-5.506 5.322 0 2.94 2.465 5.323 5.506 5.323Z",
  fill: "currentColor"
})));

export default SvgZoomIn;